import { Link } from "react-router-dom";
import { CircleSlash } from "lucide-react";
import { UpgradeButton } from "@/components/Paywall";

export default function PaymentCancel() {
  return (
    <main className="max-w-xl mx-auto px-4 py-28 text-center" data-testid="payment-cancel-page">
      <CircleSlash size={56} className="mx-auto text-slate-500" />
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase mt-6">Checkout cancelled</h1>
      <p className="text-slate-400 mt-4">No charge was made. You can upgrade any time.</p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <UpgradeButton label="Try again" />
        <Link to="/" data-testid="payment-cancel-home-link" className="inline-flex items-center h-12 px-6 border border-[#27303E] hover:border-amber-500 rounded-sm font-display font-bold uppercase transition-colors duration-200">
          Back home
        </Link>
      </div>
    </main>
  );
}
